import {Consts} from "../pages/consts";
import { useState } from "react";
import {useTranslation} from "react-i18next";
import {getInputFocusStyle} from "../pages/utils";

const AddFreeTextDrugDetails = ({onHandleSetFreeDrugDetails}) => {
  const { t } = useTranslation();
  const [otherProduct, setOtherProduct] = useState('');
  const [otherSubstance, setOtherSubstance] = useState('');
  const [isProductFocused, setIsProductFocused] = useState(false);
  const [isSubstanceFocused, setIsSubstanceFocused] = useState(false);

  const setDrugName = (value) => {
    setOtherProduct(value);
    setOtherSubstance("");
    onHandleSetFreeDrugDetails(Consts.PRODUCT, value);
  }

  const setSubstance = (value) => {
    setOtherProduct("");
    setOtherSubstance(value);
  }

  return (
    <div className="add-drug-free-grid">
      <div>
        <input
          type={Consts.TEXT}
          value={otherProduct}
          onChange={(e) => setDrugName(e.target.value)}
          onFocus={() => setIsProductFocused(true)}
          onBlur={() => setIsProductFocused(false)}
          className="w3-input w3-border w3-round form-input2"
          placeholder={t("medication_name")}
          style={getInputFocusStyle(isProductFocused)}
        />
      </div>
      <span className="add-drug-or">{t("or")}</span>
      <div>
        <input
          type={Consts.TEXT}
          value={otherSubstance}
          onChange={(e) => setSubstance(e.target.value)}
          onFocus={() => setIsSubstanceFocused(true)}
          onBlur={(e) => {
            setIsSubstanceFocused(false);
            onHandleSetFreeDrugDetails(Consts.SUBSTANCE, e.target.value)
          }}
          className="w3-input w3-border w3-round form-input"
          placeholder={t("substances")}
          style={getInputFocusStyle(isSubstanceFocused)}
        />
      </div>
    </div>
  );
}

export default AddFreeTextDrugDetails;